module.exports = __webpack_public_path__ + "media/alert.5c8db378.mp3";